<template>
  <v-container fluid>
      <v-app-bar flat>
        <v-toolbar-title>{{ t({s: 'information', component: 'Navigation'}) }}</v-toolbar-title>
      </v-app-bar>
      <InfoAlert/>
      <Tabs/>
  </v-container>
</template>

<script>
import InfoAlert from '@/components/Information/InfoAlert/InfoAlert'
import Tabs from '@/components/Information/Tabs/index'

export default {
  name: 'Information',
  components: { InfoAlert, Tabs }
}
</script>
